import { Capacitor } from '@capacitor/core';

const FALLBACK_URL = 'https://bookoll.com';

export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || FALLBACK_URL;

export const PUBLIC_HOST = (() => {
  try {
    return new URL(PUBLIC_URL).host;
  } catch {
    return new URL(FALLBACK_URL).host;
  }
})();

export const getPublicUrl = () => {
  if (Capacitor.isNativePlatform()) return PUBLIC_URL;
  const { origin, hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1' ? origin : PUBLIC_URL;
};